const errorType = "ERROR_TYPE";
const clearErrorType = "ERROR_CLEAR_TYPE";
const successType = "SUCCESS_TYPE";
const clearSuccessType = "SUCCESS_CLEAR_TYPE";
const initialState = { error: {} };

export const actionCreators = {
  sendError: error => async (dispatch, getState) => {
    dispatch({ type: errorType, error });
  },
  clearError: () => async (dispatch, getState) => {
    dispatch({ type: clearErrorType });
  },
  sendMessage: message => async (dispatch, getState) => {
    dispatch({ type: successType, message });
  },
  clearMessage: () => async (dispatch, getState) => {
    dispatch({ type: clearSuccessType });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === errorType) {
    const { error } = action;
    return {
      ...state,
      error
    };
  }

  if (action.type === clearErrorType) {
    return {
      ...state,
      error: []
    };
  }

  if (action.type === successType) {
    const { message } = action;
    return {
      ...state,
      message
    };
  }

  if (action.type === clearSuccessType) {
    return {
      ...state,
      message: undefined
    };
  }

  return state;
};
